import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Paper, Button } from '@mui/material';
import { Create as CreateIcon } from '@mui/icons-material';
import CSS from 'csstype';

import MyTitle from "~/mui/MyTitle";
import { classNames } from "~/utils/utils";

import "./style.less";

interface IPaperWithTitle {
	title: ReactNode;
	children: ReactNode;
	className?: string;
	onClick?: () => void;
	link?: string;
	linkTitle?: string;
	sx?: CSS.Properties;
	icon?: ReactNode;
	error?: boolean;
}

export default function PaperWithTitle({
	title,
	children,
	className = "",
	onClick = null,
	link = "",
	linkTitle = "",
	sx = {},
	icon = <CreateIcon sx={{ fill: "#000" }} />,
	error = false,
}: IPaperWithTitle) {
	return <Paper elevation={3} className={classNames(["paperWithTitle", error ? "error-style" : ""])}>
		<MyTitle className="paperWithTitle__myTitle">
			{ title }
			{ onClick && <Button onClick={onClick}>
				{ icon }
			</Button> }
			{ link !== "" && <Link to={link} className="paperWithTitle__titleLink">
				{ linkTitle }
			</Link> }
		</MyTitle>
		<div style={ sx } className={classNames(["paperWithTitle__content", className])}>
			{ children }
		</div>
	</Paper>;
}
